import { render, staticRenderFns } from "./ExtractSetting.vue?vue&type=template&id=0d19b5e4"
import script from "./ExtractSetting.vue?vue&type=script&lang=js"
export * from "./ExtractSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d19b5e4')) {
      api.createRecord('0d19b5e4', component.options)
    } else {
      api.reload('0d19b5e4', component.options)
    }
    module.hot.accept("./ExtractSetting.vue?vue&type=template&id=0d19b5e4", function () {
      api.rerender('0d19b5e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/ExtractSetting.vue"
export default component.exports